import { render, staticRenderFns } from "./MenuIconCard.vue?vue&type=template&id=559e374d"
import script from "./MenuIconCard.vue?vue&type=script&lang=js"
export * from "./MenuIconCard.vue?vue&type=script&lang=js"
import style0 from "./MenuIconCard.vue?vue&type=style&index=0&id=559e374d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports